// Error shape for the fetch-based API client.
//
// Kept in its own module with ZERO imports on purpose: api.js reads
// `import.meta.env`, which only exists under Vite, so it cannot be imported by
// a plain `node --test` process. This file can, which is what makes the
// contract below testable.
//
// The contract matters because lib/api.js exports an axios-SHAPED default
// (api.post(path, body)), which led several pages to assume the axios ERROR
// shape as well:
//
//   catch (err) { setError(err.response?.data?.error?.message || 'Errore…'); }
//
// The client is fetch-based and used to set only `message`/`code`/`status`, so
// that optional chain always yielded undefined and every such handler fell
// back to its generic string — a 409 "email already exists" reached the user
// as "Errore nella creazione." 18 call sites across 8 pages did this.
//
// So an API error carries BOTH shapes:
//   err.message                        — the server's message
//   err.code / err.status              — the original fetch-client fields
//   err.response.data.error.message    — the axios reading those pages expect
//   err.response.status

/**
 * @param {number} status  HTTP status of the failed response
 * @param {object} body    parsed JSON body ({} when the body was not JSON)
 * @returns {Error}
 */
export function buildApiError(status, body) {
  const payload = body && typeof body === 'object' ? body : {};
  const err = new Error(payload?.error?.message || `Errore ${status}`);
  err.code = payload?.error?.code;
  err.status = status;
  err.response = { status, data: payload };
  return err;
}

export default buildApiError;
